<template>
  <b-card no-body>
    <b-card-header class="border-bottom mb-2">
      <b-card-title>
        <div>En Çok Görüntülenenler</div>
        <b-card-sub-title style="margin-top: 1px">
          İlk 10 Ürün
        </b-card-sub-title>
      </b-card-title>
    </b-card-header>
    <b-card-body>
      <b-list-group v-if="dataList.length > 0">
        <b-list-group-item
          v-for="item in dataList"
          :key="item.id"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div class="font-weight-bold">
              {{ item.title }}
            </div>
            <div>
              <b-badge
                pill
                variant="light-info"
              >
                {{ item.count | toNumber }}
              </b-badge>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
      <b-alert
        v-else
        variant="info"
        show
      >
        <div class="alert-body text-center">
          Raporlama için veri bulunmuyor.
        </div>
      </b-alert>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BListGroup, BListGroupItem, BBadge, BCardHeader, BCardTitle, BCardSubTitle, BCardBody, BAlert,
} from 'bootstrap-vue'

export default {
  name: 'MostViewedCard',
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    BBadge,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BAlert,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
}
</script>
